// src/components/Infrastructure/Infrastructure.jsx
import React, { useEffect } from 'react';
import Navbar from '../Navbar/navbar';
import Footer from '../Footer/Footer';
import './Infrastructure.css';
import { Container, Row, Col } from 'react-bootstrap';

// Images
import imgToolRoom from '../../assets/Infrastructure/our-process-image.jpg.png';
import imgStamping from '../../assets/Infrastructure/our-story-header-img-1.jpg.png'; // Placeholder for Stamping
import imgWelding1 from '../../assets/Infrastructure/our-process-image1.jpg.png'; // Robotic Arm
import imgWelding2 from '../../assets/Infrastructure/service-entry-img-1.jpg.png'; // Anothejpg.pngr robot/machine
import Certificates from '../Certificates/Certificates';

const Infrastructure = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="infrastructure-page-wrapper mb-5">
        <Navbar />

        <section className="about-hero-section">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="about-hero-content">
                  {/* Main Title: About (Regular) Us (Bold) */}
                  <h1 className="about-hero-title">
                    <span>Infrastructure</span>
                  </h1>
                </div>
              </Col>
            </Row>
          </Container>
        </section>


        <div className="container custom-mt-nav">

          {/* --- SECTION 1: World-Class Manufacturing --- */}
          <div className="row align-items-center mb-5 ">
            {/* Left: Text */}
            <div className="col-lg-6 mb-4 mb-lg-0 pe-lg-5">

              <h1 className=" fw-bold text-dark mb-4">
                World-Class Manufacturing Infrastructure
              </h1>

              <div className="d-flex align-items-center mb-3">
                <i className="bi bi-briefcase-fill text-orange fs-4 me-3"></i>
                <div>
                  <h5 className="text-orange fw-bold mb-0">In-House Tool Room & Die Manufacturing</h5>
                  <small className="fw-bold text-dark">(Our Key Strength)</small>
                </div>
              </div>

              <p className="text-muted mb-4 text-justify">
                Our fully integrated tool room is the backbone of our manufacturing excellence. It enables us to design, develop, maintain, and modify tools internally—ensuring faster development cycles, better confidentiality, and superior quality consistency for our customers.
              </p>

              <h6 className="fw-bold text-dark mb-3">Tool Room Capabilities</h6>
              <ul className="list-unstyled text-muted mb-4 infra-list">
                <li><i className="bi bi-circle-fill text-orange small-dot me-2"></i>Progressive, compound & stage tool design</li>
                <li><i className="bi bi-circle-fill text-orange small-dot me-2"></i>Precision die manufacturing and maintenance</li>
                <li><i className="bi bi-circle-fill text-orange small-dot me-2"></i>Tool trials and optimization</li>
                <li><i className="bi bi-circle-fill text-orange small-dot me-2"></i>Rapid engineering changes & lifecycle support</li>
                <li><i className="bi bi-circle-fill text-orange small-dot me-2"></i>Reduced lead time and improved cost control</li>
              </ul>

              <p className="text-muted small border-start border-4 border-orange ps-3 fst-italic">
                This strong tooling foundation allows us to support New Product Development (NPD) programs and consistently meet demanding automotive quality standards.
              </p>
            </div>

            {/* Right: Image */}
            <div className="col-lg-6">
              <img src={imgToolRoom} alt="Tool Room" className="img-fluid rounded-4 shadow-lg w-100 object-fit-cover" style={{ height: '500px' }} />
            </div>
          </div>


          {/* --- SECTION 2: Precision Metal Stamping --- */}
          <div className="row align-items-center mb-5 pb-3">
            {/* Left: Image (Order 2 on mobile, 1 on desktop) */}
            <div className="col-lg-6 order-2 order-lg-1">
              <img src={imgStamping} alt="Metal Stamping" className="img-fluid rounded-4 shadow-lg w-100 object-fit-cover" style={{ height: '450px' }} />
            </div>

            {/* Right: Text (Order 1 on mobile, 2 on desktop) */}
            <div className="col-lg-6 order-1 order-lg-2 ps-lg-5 mb-4 mb-lg-0">
              <h1 className="fw-bold text-dark mb-4">
                Precision Metal Stamping
              </h1>
              <p className="text-muted mb-4 text-justify">
                We operate high-precision stamping presses capable of producing structural, safety, and functional automotive components with tight tolerances and consistent output.
              </p>

              <ul className="list-unstyled text-muted infra-list-large">
                <li className="mb-3 d-flex align-items-center">
                  <i className="bi bi-patch-check-fill text-orange fs-5 me-3"></i>
                  <span>Enhanced product reliability</span>
                </li>
                <li className="mb-3 d-flex align-items-center">
                  <i className="bi bi-patch-check-fill text-orange fs-5 me-3"></i>
                  <span>Compliance to Weld system Assessment CQI-15</span>
                </li>
                <li className="mb-3 d-flex align-items-center">
                  <i className="bi bi-patch-check-fill text-orange fs-5 me-3"></i>
                  <span>Compliance to Weld system Assessment CQI-15</span>
                </li>
              </ul>
            </div>
          </div>


          {/* --- SECTION 3: Robotic Welding & Assembly --- */}
          <div className="mb-5 pb-3">
            {/* Top: Header */}
            <div className="row mb-4">
              <div className="col-12">
                <h1 className="fw-bold text-dark mb-3">
                  Robotic Welding & Assembly
                </h1>
                <p className="text-muted text-justify">
                  To ensure strength, consistency, and productivity, we utilize automated and robotic welding systems, followed by precise assembly operations.
                </p>

                {/* 2-Column Features */}
                <div className="row mt-4">
                  <div className="col-md-6">
                    <ul className="list-unstyled text-muted infra-list-large">
                      <li className="mb-3 d-flex align-items-center"><i className="bi bi-patch-check-fill text-orange fs-5 me-2"></i>Weld consistency & reduced defects</li>
                      <li className="mb-3 d-flex align-items-center"><i className="bi bi-patch-check-fill text-orange fs-5 me-2"></i>Improved cycle times</li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="list-unstyled text-muted infra-list-large">
                      <li className="mb-3 d-flex align-items-center"><i className="bi bi-patch-check-fill text-orange fs-5 me-2"></i>Enhanced product reliability</li>
                      <li className="mb-3 d-flex align-items-center"><i className="bi bi-patch-check-fill text-orange fs-5 me-2"></i>Compliance to Weld system Assessment CQI-15</li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>

            {/* Bottom: Images Side by Side */}
            <div className="row g-4">
              <div className="col-md-6">
                <img src={imgWelding1} alt="Robotic Welding 1" className="img-fluid rounded-4 shadow-lg w-100 object-fit-cover" style={{ height: '350px' }} />
              </div>
              <div className="col-md-6">
                <img src={imgWelding2} alt="Robotic Welding 2" className="img-fluid rounded-4 shadow-lg w-100 object-fit-cover" style={{ height: '350px' }} />
              </div>
            </div>
          </div>

        </div>

        {/* Certification Component */}
        <Certificates />

      </div>
      <Footer />
    </>
  );
};

export default Infrastructure;